module.exports = __webpack_public_path__ + "img/janflow-rights.4a287c20.png";